import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls, apiHostUrl, unauth } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const destinationApi = createApi({
    reducerPath: 'destination',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers, unauth);
        }
    }),
   
    endpoints: (builder) => ({
        getDestinationByName: builder.query({
            query: () => ({
                url: unauth ? apiUrls?.itpNsaDestinationsUrl_ua : apiUrls?.itpNsaDestinationsUrl,
                method: 'Get'
            })
        }),
    }),

})

export const { useGetDestinationByNameQuery } = destinationApi;